export const DEFAULT_CIGS_SMOKED_DAILY = 20;
export const DEFAULT_CIGS_IN_A_PACK = 20;
export const NUMBER_OF_DAYS_IN_A_YEAR = 365;
export const PACK_PRICE_BY_STORE = {
  'juul-us': 5,
};
